export const UPDATE_LANGUAGE = 'UPDATE_LANGUAGE'
export const languagesOptions = ['ES', 'EN'] as const
export type LanguageOptions = (typeof languagesOptions)[number]

export interface TranslatableProps {
  language: LanguageOptions
}

export type LanguageState = {
  language: LanguageOptions | null
  updateLanguage: (language: LanguageOptions) => void
}

export type LanguageAction = {
  type: typeof UPDATE_LANGUAGE
  payload: LanguageOptions
}

export const isLanguageOption = (text: string): text is LanguageOptions => {
  return languagesOptions.includes(text as LanguageOptions)
}
